import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import React from 'react';
import isEqual from 'react-fast-compare';

export interface ReportProps {
    active: boolean;
    className?: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement> | null;
}

const Report = (props: ReportProps) => {
    const { active, className, onClick } = props;
    const id = active ? 'review.reported' : 'review.report';
    return (
        <Link
            className={className}
            onClick={onClick ?? undefined}
        >
            <FormattedMessage id={id} />
        </Link>
    );
};

export default React.memo<ReportProps>(Report, isEqual);
